var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main_content_top section_bottom recommend_box"},[_c('el-row',{staticClass:"top_row",attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":12,"align":"left"}},[_c('img',{staticClass:"md",attrs:{"src":require("../../assets/images/icon_13.png"),"alt":""}}),_c('img',{staticClass:"hd",staticStyle:{"width":"3px","height":"16px","vertical-align":"text-top"},attrs:{"src":require("../../assets/images/icon_13.png"),"alt":""}}),_c('span',[_vm._v("推荐阅读")])]),_c('router-link',{attrs:{"to":{
        name: '通用更多',
        query: {
          commonMoreName: '推荐阅读',
          showType: 'list',
          activeMenu: '推荐阅读'
        }
      }}},[_c('el-col',{staticClass:"desc hidden-md-and-down",attrs:{"span":12,"align":"right"}},[_vm._v("学海无涯 学无止境")])],1),_c('router-link',{attrs:{"to":{
        name: '通用更多',
        query: {
          commonMoreName: '推荐阅读',
          showType: 'list',
          activeMenu: '推荐阅读'
        }
      }}},[_c('el-col',{staticClass:"more hidden-lg-and-up",attrs:{"span":12,"align":"right"}},[_c('img',{attrs:{"src":require("@/assets/images/phone/sub_more.png"),"alt":""}})])],1)],1),_c('div',{staticClass:"recommend"},[_c('el-row',_vm._l((_vm.recommendList),function(item,index){return _c('el-col',{key:index,attrs:{"sm":24,"lg":8,"span":24},nativeOn:{"click":function($event){return _vm.handleClickOne(item)}}},[_vm._v(_vm._s(item.readName))])}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }